module.exports = __webpack_public_path__ + "img/avviso.8d5fa5df.svg";